(function () {
  const modal = document.getElementById('refundPolicyModal');
  if (!modal) return;

  // Prevent fixed-position modal from being affected by transformed ancestors
  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  const contentEl = document.getElementById('refundPolicyContent');
  const POLICY_PATH = '/policies/refund-policy';

  // Support both naming conventions
  const panel = modal.querySelector('.refund-policy-sheet, .refund-policy-modal__panel');
  const isBackdrop = (el) =>
    el === modal ||
    el.classList?.contains('refund-policy-backdrop') ||
    el.classList?.contains('refund-policy-modal__backdrop');

  let lastFocused = null;
  let loadedOnce = false;

  const FALLBACK_HTML = `
    <div style="font-size:14px; line-height:1.75; color:#111;">
      <div style="font-weight:800; margin-bottom:8px;">返品・返金ポリシー（要点）</div>
      <ul style="margin:0; padding-left:18px;">
        <li><b>返品期限：</b>商品到着後 30 日以内</li>
        <li><b>返品条件：</b>未使用・未開封（※対象外がある場合はその条件に準拠）</li>
        <li><b>不良品/誤配送：</b>当店負担で交換/返金対応</li>
        <li><b>お客様都合：</b>返送料はお客様負担（※例外がある場合は追記）</li>
        <li><b>返金方法：</b>原則としてお支払い方法に準じて返金</li>
        <li><b>手続き：</b>返品前に必ずご連絡ください（注文番号の記載）</li>
      </ul>
      <div style="margin-top:12px; font-size:13px; color:#555;">
        ※詳細は右上の「別タブで開く」から全文をご確認ください。
      </div>
    </div>
  `;

  function showLoading() {
    if (!contentEl) return;
    contentEl.innerHTML = '<div class="refund-policy-loading">読み込み中...</div>';
  }

  function showFallback() {
    if (!contentEl) return;
    contentEl.innerHTML = FALLBACK_HTML;
  }

  function sanitizeContainer(container) {
    container
      .querySelectorAll('script, style, link, iframe, object, embed, form, input, button')
      .forEach((el) => el.remove());
    container.querySelectorAll('a[href]').forEach((a) => {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
    return container;
  }

  async function fetchWithTimeout(url, ms) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), ms);
    try {
      return await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        headers: { Accept: 'text/html' },
      });
    } finally {
      clearTimeout(t);
    }
  }

  function extractPolicyContentHTML(doc) {
    const container = doc.querySelector('.shopify-policy__container');
    if (container && container.textContent.trim().length > 200) return container.innerHTML;

    const body = doc.querySelector('.shopify-policy__body');
    if (body && body.textContent.trim().length > 200) return body.innerHTML;

    const blocks = Array.from(
      doc.querySelectorAll('.shopify-policy__body, main .rte, main article, #MainContent .rte')
    ).filter((n) => n && n.textContent.trim().length > 0);

    if (blocks.length) {
      const uniq = [];
      const seen = new Set();
      for (const b of blocks) {
        const key = b.textContent.trim().slice(0, 80);
        if (!seen.has(key)) {
          seen.add(key);
          uniq.push(b);
        }
      }
      const merged = uniq.map((n) => n.innerHTML).join('\n');
      if (merged.trim().length > 200) return merged;
    }

    const main = doc.querySelector('#MainContent') || doc.querySelector('main');
    if (main && main.textContent.trim().length > 200) return main.innerHTML;

    return null;
  }

  async function loadPolicyOnce() {
    if (loadedOnce || !contentEl) return;

    showLoading();

    try {
      const res = await fetchWithTimeout(POLICY_PATH, 8000);
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const htmlText = await res.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');

      const extractedHTML = extractPolicyContentHTML(doc);
      if (!extractedHTML) throw new Error('BodyNotFound');

      const wrapper = document.createElement('div');
      wrapper.innerHTML = extractedHTML;
      const clean = sanitizeContainer(wrapper);

      const note = document.createElement('div');
      note.style.fontSize = '13px';
      note.style.color = '#555';
      note.style.marginBottom = '10px';
      note.textContent =
        '※全文をこの画面でご確認いただけますが、リンクを選択して別タブで開くこともできます。';

      contentEl.innerHTML = '';
      contentEl.appendChild(note);
      contentEl.appendChild(clean);

      loadedOnce = true;
    } catch (e) {
      showFallback();
      console.warn('[RefundPolicyModal] load failed:', e);
    }
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    const closeBtn = modal.querySelector('[data-refund-close], .refund-policy-close');
    if (closeBtn) closeBtn.focus();

    loadPolicyOnce();
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Event delegation: open anywhere
  document.addEventListener(
    'click',
    (e) => {
      const openEl = e.target.closest('.refund-policy-trigger');
      if (openEl) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
        return;
      }

      const closeEl = e.target.closest('[data-refund-close]');
      if (closeEl) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      }
    },
    true
  );

  // Backdrop click
  modal.addEventListener('click', (e) => {
    if (panel && panel.contains(e.target)) return;
    if (isBackdrop(e.target)) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') closeModal();
  });
})();